module.exports = __webpack_public_path__ + "static/media/selvfølge.aa4380a0.mp3";